var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSizemdPaymentmethodTwint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "black",
    stroke: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0847 19.0449C14.0847 19.2171 13.9597 19.4302 13.8097 19.5121L8.45169 22.553C8.3017 22.6432 8.05171 22.6432 7.90172 22.553L2.54369 19.5121C2.3937 19.422 2.26871 19.2171 2.26871 19.0449V12.955C2.26871 12.7829 2.3937 12.5698 2.54369 12.4878L7.90172 9.44692C8.05171 9.35676 8.3017 9.35676 8.45169 9.44692L13.8097 12.4878C13.9597 12.578 14.0847 12.7829 14.0847 12.955V19.0449Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5745 13.2851H38.761V14.3952H40.4824V19.1603H41.8447V14.3952H43.5745V13.2851Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7133 13.2851H16.8999V14.3952H18.6297V19.1603H19.9919V14.3952H21.7133V13.2851Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6439 13.0988C34.1313 13.0988 33.2873 14.0388 33.2873 15.3921V19.1603H34.6327V15.3597C34.6327 14.7681 34.9921 14.3143 35.6606 14.3143C36.3208 14.3143 36.6801 14.8492 36.6801 15.3597V19.1603H38.0256V15.3921C38.0256 14.0388 37.1565 13.0988 35.6439 13.0988Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5548 13.2851V19.1603H31.9084V13.2851H30.5548Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.992 15.619L26.042 15.8783L27.3039 19.1603H27.8555L29.5769 13.2851H28.2482L27.4208 16.3728L27.3791 16.7048L27.3123 16.3728L26.209 13.2851H25.7746L24.6798 16.3728L24.6129 16.7048L24.5629 16.3728L23.7438 13.2851H22.4152L24.1369 19.1603H24.6882L25.95 15.8783L25.992 15.619Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_734_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6656 15.8855L9.29101 17.8279L8.58315 16.7856L9.39801 15.617C9.54617 15.4117 9.87541 14.8354 9.49678 14.0537C9.19224 13.422 8.53376 13.1141 7.95759 13.1141C7.38143 13.1141 6.74764 13.3983 6.41841 14.0537C6.03978 14.8038 6.36902 15.396 6.50895 15.5934C6.50895 15.5934 6.96165 16.2329 7.34027 16.7698L7.95759 17.6226L8.87946 18.9728C8.88769 18.9807 9.03585 19.1939 9.29101 19.1939C9.53794 19.1939 9.68609 18.9807 9.71079 18.957L11.8755 15.8855H10.6656ZM7.95759 15.9329C7.95759 15.9329 7.59543 15.4039 7.36497 15.0406C7.10981 14.6459 7.39789 14.0616 7.95759 14.0616C8.52553 14.0616 8.80538 14.6459 8.55022 15.0406C8.31976 15.4117 7.95759 15.9329 7.95759 15.9329V15.9329Z",
    fill: "url(#paint0_radial_734_254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62417 17.7645L5.26607 15.9405C5.26607 15.9405 4.9039 15.4115 4.67344 15.0483C4.41828 14.6535 4.70636 14.0692 5.26607 14.0692C5.34014 14.0692 5.40599 14.0771 5.46361 14.0929L5.941 13.256C5.71877 13.1691 5.4883 13.1217 5.26607 13.1217C4.6899 13.1217 4.05612 13.406 3.72688 14.0613C3.34825 14.8114 3.67749 15.4036 3.81742 15.601L6.18793 18.9725C6.20439 19.0041 6.36078 19.2173 6.60771 19.2173C6.86287 19.2173 7.0028 19.012 7.02749 18.9804L7.74358 17.9382L7.12626 17.0697L6.62417 17.7645Z",
    fill: "url(#paint1_radial_734_254)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_734_254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.50182 13.6045) scale(6.37678 6.31506)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09157,
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1739,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2528,
    stopColor: "#FFAB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4046,
    stopColor: "#FF7000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4786,
    stopColor: "#FF4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5503,
    stopColor: "#FF1800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5822,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_734_254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.6579 13.72) scale(5.84699 5.79043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#00B0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#01A5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5737,
    stopColor: "#0292CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7546,
    stopColor: "#0377BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9316,
    stopColor: "#0455A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054696"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_734_254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.32462,
    height: 6.10348,
    fill: "white",
    transform: "translate(3.55081 13.1141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizemdPaymentmethodTwint);
export default __webpack_public_path__ + "static/media/Size=md, Payment method=Twint.dc5c39c7.svg";
export { ForwardRef as ReactComponent };